import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { State } from "./index";
import type { AppDispatch } from "./index";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<State> = useSelector;
